import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import List from '@/components/List'
import EndList from '@/components/EndList'
import ApprovalIndex from '@/components/ApprovalIndex'
import Temp from '@/components/Temp'
import Test from '@/components/Test'
import Project from '@/components/Project'
import Viewpdf from '@/components/Viewpdf'
import Report from '@/components/Report'
import Help from '@/components/Help'
import Closure from '@/components/Closure'
import Practice from '@/components/Practice'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/List',
      name: 'List',
      component: List
    },
    {
      path: '/EndList',
      name: 'EndList',
      component: EndList,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/ApprovalIndex',
      name: 'ApprovalIndex',
      component: ApprovalIndex,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/Temp',
      name: 'Temp',
      component: Temp
    },
    {
      path: '/Test/:projectID',
      name: 'Test',
      component: Test
    },
    {
      path: '/Project',
      name: 'Project',
      component: Project
    },
    {
      path: '/Help',
      name: 'Help',
      component: Help
    },
    {
      path: '/Viewpdf',
      name: 'Viewpdf',
      component: Viewpdf
    },
    {
      path: '/Report',
      name: 'Report',
      component: Report
    },
    {
      path: '/Closure',
      name: 'Closure',
      component: Closure
    },
    {
      path: '/Practice',
      name: 'Practice',
      component: Practice
    },
    
   
   

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js